<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Add Role</h3>
            </div>
            <v-form
              class="v-form-body"
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <label class="form-control-label">
                    Role
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="role.name"
                    placeholder="Add new role"
                    :rules="[(v) => !!v || 'Role is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                    required
                    solo
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-card-title class="pt-8">
                    <h4>Active</h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="role.active"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-card-title class="pt-8">
                    <h4>Visible to Doctor?</h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="role.show"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>
              </v-row>
              <card shadow>
                <div class="permission-header">
                  <div>
                    <h3 class="permission-header-name">Permissions</h3>
                  </div>
                </div>
                <div class="card-body">
                  <!-- <v-row class="ma-0">
                    <v-col cols="12" class="pb-0 pt-5">
                     <span class="font-weight-medium">
                        Menu(module) access
                     </span>
                     <v-divider class="ma-0 mt-1"></v-divider>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="3">
                     <v-checkbox
                      v-model="allModulesSelected"
                      @change="
                        selectAllModules(
                          $event,
                          modulesArray
                        )
                      "
                      label="Select All"
                    ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="3"
                      v-for="(moduleObj, index) in modulesArray"
                      :key="index"
                    >
                      <v-checkbox
                          class="check-bx"
                          v-model="role.modules[0][index]"
                          :label="moduleObj.title"
                        ></v-checkbox>
                    </v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-expansion-panels focusable>
                        <v-expansion-panel
                          v-for="(module, moduleKey) in apisListArray"
                          :key="moduleKey"
                        >
                          <v-form>
                            <v-expansion-panel-header>{{
                              module.title
                            }}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col cols="4">
                                  <v-checkbox
                                    v-model="selectAllField[moduleKey]"
                                    @change="
                                      selectAll(
                                        $event,
                                        moduleKey,
                                        apisListArray[moduleKey].apis
                                      )
                                    "
                                    label="Select All"
                                    hide-details
                                  ></v-checkbox>
                                </v-col>
                                <v-col
                                  cols="4"
                                  v-for="(api, j) in apisListArray[moduleKey]
                                    .apis"
                                  :key="j"
                                >
                                  <v-checkbox
                                    class="check-bx"
                                    v-model="role.permissions[moduleKey]"
                                    :label="`${api.title}`"
                                    :value="`${api.path}`"
                                    hide-details
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-form>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </div>
              </card>
              <v-col class="text-right pt-8 pb-3 px-0" cols="12">
                <v-btn color="#989898" class="mr-4 white--text" @click="cancel"
                  >Cancel</v-btn
                >
                <v-btn
                  :disabled="!valid"
                  color="#344452"
                  class="white--text"
                  :loading="loading"
                  @click="validate"
                  >Add</v-btn
                >
              </v-col>
            </v-form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommonSection from "@/components/CommonHeader";
import { RoleService } from "@/services";
import { MODULE_API_LIST } from "@/constants";

export default {
  name: "AddRole",
  components: {
    CommonSection,
  },
  data: function () {
    return {
      valid: true,
      modulesArray: [],
      apisListArray: [],
      modules: {},
      loading: false,
      role: {
        name: null,
        permissions: {},
        active: true,
        show: false,
        //modules: [],
      },
      selectAllField: [],
      allModulesSelected:true
    };
  },

  mounted() {
    this.getRouteList();
  },
  watch: {
    "role.permissions": {
      handler: function (newPermissions) {
        let permissionsArray = newPermissions;
        for (const [itemIndex, apisData] of Object.entries(permissionsArray)) {
          this.selectAllField[itemIndex] = false;
          if (this.apisListArray[itemIndex].apis.length == apisData.length) {
            this.selectAllField[itemIndex] = true;
          }
        }
      },
      deep: true,
    },
    "role.modules": {
      handler: function (newModules) {
        
        let selectedModuleCounts = 0
        for (const [module] of Object.entries(newModules[0])) {
         if(module) selectedModuleCounts++
        }
        this.selectAllModules = (selectedModuleCounts == Object.keys(this.modulesArray).length) ? true : false;
        
        let updatedModulesVal = newModules[0];
        for (const [moduleKey, apiList] of Object.entries(MODULE_API_LIST[0])) {
          for (const [permissionKey, apisArray] of Object.entries(apiList[0])) {
            if (updatedModulesVal[moduleKey]) {
              let permissionArray = this.role.permissions[permissionKey];
              permissionArray =
                permissionArray.length > 0
                  ? permissionArray.concat(apisArray)
                  : apisArray;
              this.$set(
                this.role.permissions,
                permissionKey,
                permissionArray
              );
            } else {
              this.$set(this.role.permissions, permissionKey, []);
            }
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    selectAllModules(event){
      let temp = {}
      for (const [key] of Object.entries(this.role.modules[0])) {
        temp[key] = (event) ? true : false;
      }
      this.role.modules[0] = temp;
    },
    async getRouteList() {
      const response = await RoleService.routeList();
      this.modulesArray =
        response.data.moduleList.modules.length > 0
          ? response.data.moduleList.modules[0]
          : [];
      this.apisListArray = response.data.apiList ? response.data.apiList : [];

      //this.role.modules = [];
      // let modulestObj = {};
      // for (const [key, module] of Object.entries(this.modulesArray)) {
      //   modulestObj[key] = module.value;
      // }
      //this.role.modules.push(modulestObj);

      this.role.permissions = {};
      let apisListObj = {};
      for (const [itemIndex] of Object.entries(this.apisListArray)) {
        apisListObj[itemIndex] = [];
      }
      this.role.permissions = apisListObj;
    },
    selectAll(event,itemIndex, items) {
      let selectedAll = [];
      if(!event){
        this.$set(this.role.permissions, itemIndex, []);
        return
      }
      for (let i in items) {
        let isExists = this.role.permissions[itemIndex].includes(items[i].path);
        if (!isExists) {
          selectedAll[i] = items[i].path
        } else {
          const index = this.role.permissions[itemIndex].findIndex(
            (x) => x == items[i].path
          );
          if (this.selectAllField[itemIndex] == true) {
            selectedAll[i] = items[i].path
            this.$set(this.role.permissions, itemIndex, selectedAll);
          } else {
            this.role.permissions.splice(index, 1);
          }
        }
      }
      this.role.permissions[itemIndex] = selectedAll;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await RoleService.createRole(this.role);
          if (response) {
            this.$router.push("/roles");
            this.$store.dispatch("user/setSnack", "Role Created.");
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
        }
        this.loading = false;
      }
    },

    cancel() {
      this.$router.push("/roles");
    },
  },
};
</script>